
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaPlay as ObiMediaPlayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-play.js';
 
 
 

 
 export const ObiMediaPlay = createComponent({
   react: React,
   tagName: 'obi-media-play',
   elementClass: ObiMediaPlayElement,
   events: {
     
   }
  });
 
 